import { render, staticRenderFns } from "./ContractOrgAttorney.vue?vue&type=template&id=25e0db40&scoped=true&"
import script from "./ContractOrgAttorney.vue?vue&type=script&lang=js&"
export * from "./ContractOrgAttorney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e0db40",
  null
  
)

export default component.exports